'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article8() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задачи:
					</Typography>
					<Typography variant='p1'>
						После деловой поездки на завод в марте 2022 года перед нами встала задача — предложить такие
						ИТ-решения, которые помогут обеспечить контроль на стадиях приемки и распределения зерна, а также на
						этапе учета готовой продукции в цеху. Помимо этого необходимо интегрировать разрабатываемое ПО и
						существующую на предприятии ERP.
					</Typography>
					<Typography variant='p1'>
						Цифровая трансформация производства включает в себя интеграцию цифровых технологий в процессы и
						продукты для повышения эффективности и качества производительности.
					</Typography>
					<Typography variant='p1'>
						Ожидания клиентов и усиление конкуренции являются основными движущими силами цифровой трансформации в
						производстве, как и в других отраслях. Используя цифровые технологии, производители могут повысить
						скорость и эффективность, масштабировать бизнес, снизить затраты и повысить качество обслуживания
						клиентов. С этими задачами к нам и обратился наш заказчик.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Выполненные работы:
					</Typography>
					<Typography variant='p1'>
						Автоматизирована пропускная система с использованием компьютерного зрения для распознавания номеров
						автомобилей и их габаритов.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/8-1.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Разработан проект автоматической системы распределения зерна по бункерам для формирования помольной
						партии.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/8-2.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Внедрена система учета норм выработки сотрудников с использованием машинного зрения и интеграции
						весового оборудования с системой бухгалтерского и складского учета.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/8-3.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Разработан проект по маркировке и учету готовой продукции с помощью технологий машинного зрения и
						цветового штрихкодирования.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/8-4.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Результат:
					</Typography>
					<Typography variant='p1'>
						Производственные мощности завода позволяли выпускать больше продукции, чем на момент обращения в
						true.code, но без цифровизации это было невозможно. На выходе получили ускорение производственных
						процессов и внедрение новых подходов в учете продукции, что позволило увеличить объемы производства,
						сократив нагрузку на штат сотрудников предприятия.
					</Typography>
				</section>

				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
